import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Beklenmeyen bir hata oluştu.";

    return Promise.reject(new Error(message));
  }
);

export const getCarInfo = async (qrCode) => {
  const response = await api.get(`/customer/${qrCode}`);
  return response.data;
};

export const requestDelivery = async (qrCode, data) => {
  const response = await api.post(`/customer/${qrCode}/request-delivery`, data);
  return response.data;
};

export default api;
